import { Model } from '@kaiser-software/chassis-core';

export class CategoryModel extends Model {

    public title: string;

    public created_at: string;

    public updated_at: string;

    public urgent: boolean;

    public category: CategoryModel;

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/models/category.model.ts